<template>
    <div class="grid-form-jobs">
        <div class="form-left">
            <div>
                <p>{{$trans.get('jobs.studentform.subtitle1')}}</p>
            </div>
                <floating-input
                    dark
                    class="mt-6"
                    name="name"
                    :placeholder="$trans.get('jobs.studentform.name')"
                    type="text"
                    :initial-value="student.name"
                    @input="student.name = $event"
                ></floating-input>
                <span class="m-0 text-sm text-red">{{errors.name}}</span>
                <floating-input
                    dark
                    class="mt-6"
                    name="birthday"
                    :placeholder="$trans.get('jobs.studentform.birthdate')"
                    type="date"
                    :initial-value="student.birthday"
                    @input="student.birthday = $event"
                ></floating-input>
                <span class="m-0 text-sm text-red">{{errors.birthday}}</span>
                <floating-input
                    dark
                    class="mt-6"
                    name="phone"
                    :placeholder="$trans.get('jobs.studentform.phone')"
                    type="tel"
                    :initial-value="student.phone"
                    @input="student.phone = $event"
                ></floating-input>
                <span class="m-0 text-sm text-red">{{errors.phone}}</span>
                <floating-input
                    dark
                    class="mt-6"
                    name="email"
                    :placeholder="$trans.get('jobs.studentform.email')"
                    type="email"
                    :initial-value="student.email"
                    @input="student.email = $event"
                ></floating-input>
                <span class="m-0 text-sm text-red">{{errors.email}}</span>
                <floating-input
                    dark
                    class="mt-6"
                    name="address"
                    :placeholder="$trans.get('jobs.studentform.address')"
                    type="text"
                    :initial-value="student.address"
                    @input="student.address = $event"
                ></floating-input>
                <span class="m-0 text-sm text-red">{{errors.address}}</span>
                <floating-input
                    dark
                    class="mt-6"
                    name="postalcode"
                    :placeholder="$trans.get('jobs.studentform.postalcode')"
                    type="number"
                    :initial-value="student.postalcode"
                    @input="student.postalcode = $event"
                ></floating-input>
                <span class="m-0 text-sm text-red">{{errors.postalcode}}</span>
                <floating-input
                    dark
                    class="mt-6"
                    name="city"
                    :placeholder="$trans.get('jobs.studentform.city')"
                    type="text"
                    :initial-value="student.city"
                    @input="student.city = $event"
                ></floating-input>
                <span class="m-0 text-sm text-red">{{errors.city}}</span>
                <div class="mt-6">
                    <label class="mb-3" for="file">{{$trans.get('jobs.studentform.file')}}  (Word, PDF, etc) </label>
                    <input class="mt-3" id="file" type="file" name="file" @change="previewFiles" accept=".doc,.docx,.pdf">
                    <span class="m-0 text-sm text-red">{{errors.file}}</span>
                </div>
            </div>
        <div class="form-right mt-6 lg:mt-0">
            <div>
                <p>{{$trans.get('jobs.studentform.subtitle2')}}</p>
            </div>
            <floating-input
                    dark
                    class="mt-6"
                    name="speciality"
                    :placeholder="$trans.get('jobs.studentform.speciality')"
                    type="text"
                    :initial-value="student.speciality"
                    @input="student.speciality = $event"
                ></floating-input>
                <span class="m-0 text-sm text-red">{{errors.speciality}}</span>

                <floating-input
                    dark
                    class="mt-6"
                    name="sudies_date_end"
                    :placeholder="$trans.get('jobs.studentform.years')"
                    type="text"
                    :initial-value="student.sudiesDateEnd"
                    @input="student.sudiesDateEnd = $event"
                ></floating-input>
                <span class="m-0 text-sm text-red">{{errors.sudiesDateEnd}}</span>
                <floating-textarea
                    dark
                    class=""
                    name="workexperience"
                    :placeholder="$trans.get('jobs.studentform.experience')"
                    :initial-value="student.workexperience"
                    @input="student.workexperience = $event"

                ></floating-textarea>
                <span class="m-0 text-sm text-red">{{errors.workexperience}}</span>
                <floating-textarea
                    dark
                    class="mt-6"
                    name="observations"
                    :placeholder="$trans.get('jobs.studentform.observations')"
                    :initial-value="student.observations"
                    @input="student.observations = $event"
                ></floating-textarea>
                <span class="m-0 text-sm text-red">{{errors.observations}}</span>
                <div class="flex justify-end items-center mt-2">
                    <div class="flex justify-center items-center gap-4 mt-4">
                        <input id="privacy" v-model="privacyConsent" class="form-check-input" type="checkbox">
                        <label for="privacy" class="form-check-label text-small relative">
                            <p class="text-left mb-2 pr-2">
                                {{ $trans.get('wizard.step3.privacy-consent') }}
                                <a :href="privacyConsentLink" target="_blank" class="underline">{{ $trans.get('wizard.step3.privacy-consent-link') }}</a>.
                            </p>
                        </label>
                    </div>
                    <loading-button
                        @click.native="sendForm"
                        :loading="loading"
                        class="btn btn-primary has-spinner"
                        :disabled="buttonIsDisabled"
                        :class="{'disabled': buttonIsDisabled}"
                    >
                        Enviar
                    </loading-button>
                    <!-- <button class="btn btn-primary" @click="sendForm">Enviar</button> -->
                </div>
                
        </div>
        <form-success :message="message"></form-success>
    </div>
</template>

<script>
import axios from 'axios';
import FormSuccess from './FormSuccess';
import {MDCDialog} from '@material/dialog';

export default {
    components:{
        FormSuccess
    },
    computed: {
        buttonIsDisabled() {
            return !this.privacyConsent;
        },
        privacyConsentLink() {
            return window.appLocale === 'es' ? '/es/politica-de-privacidad' : '/ca/politica-de-privacitat';
        },
    },
    data() {
        return {
            student:{
                name: '',
                birthday:'',
                phone: '',
                file: '',
                email:'',
                address:'',
                postalcode: '',
                city:'',
                speciality: '',
                sudiesDateEnd: '',
                workexperience: '',
                observations: '',
                recaptcha_token: ''
            },
            errors:{
                name: '',
                birthday:'',
                phone: '',
                file: '',
                email:'',
                address:'',
                postalcode: '',
                city:'',
                speciality: '',
                sudiesDateEnd: '',
                workexperience: '',
                observations: '',
            },
            isvalid: false,
            loading:false,
            privacyConsent:false,
            dialog:'',
            message:'',
            recaptchaSiteKey: window.recaptchaSiteKey, 
        }
    },
    mounted(){
        this.dialog = new MDCDialog(document.querySelector('.mdc-dialog'));
        const script = document.createElement('script');
        script.src = `https://www.google.com/recaptcha/api.js?render=${this.recaptchaSiteKey}`;
        script.async = true;
        document.head.appendChild(script);
    },
    methods: {
        sendForm() {
            this.validate()
            if(this.isvalid && this.privacyConsent){
                this.loading = true;
                grecaptcha.ready(() => {
                    grecaptcha.execute(this.recaptchaSiteKey, { action: 'submit' }).then((token) => {
                        this.student.recaptcha_token = token;
                        const config = {
                            headers: {
                                'content-type': 'multipart/form-data',
                                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
                            }
                        }
                        const data = new FormData();
                        for (const key in this.student) {
                            data.append(key, this.student[key]);
                        }
                        axios.post('/api/students', data, config)
                            .then(res => {
                                console.log(res.data.message)
                                this.success();
                            })
                            .catch(e => {
                                console.log(e);
                                this.loading = false;
                            });
                    }).catch(error => {
                        console.error('Error executing reCAPTCHA:', error);
                        this.loading = false;
                    });
                });
            }else{
                console.error('completa todos los campos');
            }
        },
        validate(){
            this.isvalid = true;
            for(const field in this.student){
                if (field !== 'recaptcha_token' && !this.valid(field)) {
                    this.isvalid = false;
                }
            }
        },
        valid(field){
            this.errors[field] = '';
            if(!this.student[field]) {
                this.errors[field] = this.$trans.get('jobs.required');
                return false;
            }
            return true;
        },
        success(){
            this.message = '¡El formulario ha sido enviado con éxito!';
            this.dialog.open();
            setTimeout(() => {
               window.location.href = '/';
            }, 3000);
        },
        previewFiles(event) {
            this.errors.file = '';
            console.log(event.target.files[0]);
            if(event.target.files[0].type == 'application/msword' || event.target.files[0].type == 'application/pdf'){
                   this.student.file = event.target.files[0];
                   console.log(this.student.file);
            }else{
                 this.errors.file = 'formato incorrecto'
            }



        }
    },
}
</script>
<style lang="scss" scoped>
.text-red{
    color: red;
}
</style>
